
import React from 'react';
import Hero from "../components/Hero.jsx"
import Navbar from "../components/Navbar.jsx"
import Quote from "../components/Quote.jsx"
import Passion from "../components/Passion.jsx"
import Features from "../components/Features.jsx"
import CalltoAction from '../components/CalltoAction.jsx';
import Footer from '../components/Footer';
import SwiperTestimonials from '../components/TestimonialsSlider.jsx';
// import AboutSection from '../components/AboutSection';
// import ServicesSection from '../components/ServicesSection';
// import Testimonials from '../components/Testimonials';
// import CallToAction from '../components/CalltoAction';


export default function Home() {
  return (
    <div className="bg-white text-gray-900">
      <Navbar />

      <Hero />
      <Quote />
      <Passion />
      <Features />
        <SwiperTestimonials />

    
      <Footer />

    </div>
  );
}
